import { Main } from './components/containers/Main';

export const CourierFilesList = () => {
    return <Main />;
};
